<template lang="pug">
  .contacts-page.page
    .container.contacts-page__container
      .contacts-page__block
        section.contacts-page__section.section
          .section__title
            h2.title Напишите нам
          .section__body
            form
              contacts-form
      .contacts-page__block
        section.contacts-page__section.section
          .section__title
            h2.title Контакты
          .section__body
            <!--h3.contacts-title По техническим вопросам обращаться:-->
            .contacts-list
              <!--.contacts-list__item.contact-->
                <!--.contact__icon-->
                  <!--img(src="@/assets/images/icons/geo.svg")-->
                <!--.contact__body-->
                  <!--a(href="https://yandex.ru/maps/-/CCe07Ql-" target="_blank").link ул. Сафьян, д.5, Казань, Респ. Татарстан, 420021-->
              <!--.contacts-list__item.contact-->
                <!--.contact__icon-->
                  <!--img(src="@/assets/images/icons/web.svg")-->
                <!--.contact__body-->
                  <!--a(href="http://minmol.tatarstan.ru").link minmol.tatarstan.ru-->
              .contacts-list__item.contact
                .contact__icon
                  img(src="@/assets/images/icons/phone.svg")
                .contact__body
                  a(href="tel:8-843-222-9150").link +7 (843) 207-28-45
                  span  - по вопросам приобретения путевок
              .contacts-list__item.contact
                .contact__icon
                  img(src="@/assets/images/icons/email.svg")
                .contact__body
                  a(href="mailto:mdmrt@tatar.ru").link dol.support@tatar.ru
                  span  - по техническим вопросам
        section.contacts-page__section.section
          h2.section__title
            .title Мы в социальных сетях
          .section__body
            social-networks-list(
            :links="socialNetworks"
            )
    .contacts-page__footer.page__footer
      main-footer
</template>

<script>
import MainFooter from "@/components/footer/Footer.vue";
import ContactsForm from "./components/ContactsForm";
import SocialNetworksList from "@/components/socialNetworksList/SocialNetworksList";

export default {
  name: "Contacts",
  components: {
    SocialNetworksList,
    ContactsForm,
    MainFooter
  },
  data() {
    return {
      socialNetworks: [
        {
          url: "https://vk.com/minmol_rt",
          icon: require("@/assets/images/icons/vk.svg")
        },
        {
          url: "https://www.facebook.com/minmol.rt/",
          icon: require("@/assets/images/icons/fb.svg")
        },
        {
          url: "https://twitter.com/minmol_rt ",
          icon: require("@/assets/images/icons/tw.svg")
        },
        {
          url: "https://www.instagram.com/minmol_rt/ ",
          icon: require("@/assets/images/icons/inst.svg")
        }
      ]
    };
  }
};
</script>
